export default __webpack_public_path__ + "asset/cambodia.d8666271a3297b10bc71983cc743fbce.svg";